import { createMVCommentAttachmentsUppy } from '@services/MVCommentAttachmentsUppy';

const uppyCache = new Map<
  string,
  ReturnType<typeof createMVCommentAttachmentsUppy>
>();

function getOrCreateUppy(assetId: string) {
  let ctx = uppyCache.get(assetId);
  if (!ctx) {
    ctx = createMVCommentAttachmentsUppy(assetId);
    uppyCache.set(assetId, ctx);
  }
  return ctx;
}

export function useMVCommentAttachUppy(assetId: string) {
  return getOrCreateUppy(assetId).uppy;
}
